/**
 * 生产报废原因字典
 *
 * 来源：质量与产能报表(1).xlsx 中的「缺陷类型 / 不良项明细」
 * 注意：与 backend/app/utils/scrap_reasons.py 保持同步
 */

export const SCRAP_REASONS = [
  {
    category: '碰伤',
    items: [
      { code: 'A1', name: '周刃崩缺' },
      { code: 'A2', name: '端刃崩缺' },
      { code: 'A3', name: '磨削伤刃' },
    ],
  },
  {
    category: '干涉',
    items: [
      { code: 'B1', name: '周齿翻边' },
      { code: 'B2', name: '双刀花或多刀面' },
      { code: 'B3', name: '切点相离或相离' },
      { code: 'B4', name: '啃刀' },
      { code: 'B5', name: '高点' },
    ],
  },
  {
    category: '震刀',
    items: [
      { code: 'C1', name: '周刃平台' },
      { code: 'C2', name: '周刃让刀' },
      { code: 'C3', name: '震刀纹' },
    ],
  },
  {
    category: '抛光不良',
    items: [
      { code: 'D1', name: '刃口锯齿' },
      { code: 'D2', name: '前刀面光度偏差' },
      { code: 'D3', name: '后刀面光度偏差' },
      { code: 'D4', name: '磨削烧伤' },
    ],
  },
  {
    category: '断裂',
    items: [
      { code: 'F1', name: '磨削断裂' },
      { code: 'F2', name: '材料断裂或来料不良' },
    ],
  },
  {
    category: '尺寸',
    items: [
      { code: 'E1', name: '跳动超差' },
      { code: 'E2', name: '外径超差' },
      { code: 'E3', name: '偏心/过心超差' },
      { code: 'E4', name: '轮廓不良' },
      { code: 'E5', name: '周刃/端刃宽超差' },
      { code: 'E6', name: '刃长超差' },
      { code: 'E7', name: '刀尖带起不良' },
      { code: 'E8', name: '避空尺寸不够' },
      { code: 'E9', name: '清根不到位' },
      { code: 'E10', name: '锥度超差' },
      { code: 'E11', name: '圆柱刃带不良' },
      { code: 'E12', name: '螺旋角超差' },
      { code: 'E13', name: '芯经超差' },
      { code: 'E14', name: '异常报废' },
      { code: 'E15', name: '周、端前后角超差' },
      { code: 'E16', name: '总长超差' },
    ],
  },
  {
    category: '其它',
    items: [
      { code: 'OTHER_01', name: '返修报废' },
      { code: 'OTHER_02', name: '调机报废' },
      { code: 'OTHER_03', name: '前段报废' },
      { code: 'OTHER_04', name: '辅助设备' },
      { code: 'OTHER_05', name: '端刀检测' },
      { code: 'OTHER_06', name: '包装前检验' },
      { code: 'OTHER_07', name: '涂层后缺陷' },
    ],
  },
];

export const FLAT_SCRAP_REASONS = SCRAP_REASONS.flatMap((group) =>
  group.items.map((item) => ({
    code: item.code,
    category: group.category,
    name: item.name,
    label: `${group.category} - ${item.code}(${item.name})`,
  }))
);

export function findScrapReason(code) {
  for (const group of SCRAP_REASONS) {
    const item = group.items.find((i) => i.code === code);
    if (item) {
      return { code, category: group.category, name: item.name };
    }
  }
  return null;
}
